import { useTranslation } from 'react-i18next'
import LandingServices from "./LandingServices/LandingServices"
import LandingAboutUs from "./LandingAboutUs/LandingAboutUs"
import LandingDevSteps from "./LandingDevSteps/LandingDevSteps"
import Banner from "../Banner"
import Testimonials from "../Testimonials/Testimonials"
import DividerLine from "../DividerLine"
import brain from "../../assets/images/brain-landing-bg.svg"

const Landing = () => {
    const { t } = useTranslation()

    return (
        <div>
            <div className="flex items-center justify-evenly h-auto px-8 lg:px-24">
                <h1 className="h1-landing flex-col no-selection">{ t('brand_name') }</h1>
                <img src={brain} alt="brain" className="w-1/3 z-10" />
            </div>

            <LandingServices/>

            <LandingAboutUs/>

            <Testimonials/>

            <DividerLine />

            <LandingDevSteps/>

            <Banner title={ t('landing_banner') } call={ t('landing_banner_button') } link={'/contact'}/>
        </div>
    )
}

export default Landing